import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  Link,
  MessageBox,
  MESSAGE_BOX_VARIANT_INFO,
  LINK_VARIANT_DEFAULT_NEGATIVE,
  SpacingVertical,
  SPACING_24,
  Flex
} from 'mailup-web-components'

import { pageState } from 'Pages/EmailSendingWizard/recoil/state/page'
import { senderInfoState } from 'Pages/EmailSendingWizard/recoil/state/senderInfo'
import { sendingSegmentationCallback } from '../recoil/callbacks/callback'

const SegmentationMessageBox = () => {
  const intl = useIntl()
  const { showSegmentationMessage } = useRecoilValue(pageState)
  const { queued, lastSendingId } = useRecoilValue(senderInfoState)

  const segmentation = useRecoilCallback(sendingSegmentationCallback, [])

  const onSegmentationInfoClick = e => {
    e.stopPropagation()
    segmentation(lastSendingId)
  }

  return showSegmentationMessage ? (
    <>
      <MessageBox variant={MESSAGE_BOX_VARIANT_INFO}>
        {intl.formatMessage({
          id: 'Load.EmailSendingWizard.SegmentationInfo1New'
        })}
        <SpacingVertical variant={SPACING_24} />
        <Flex columnGap='4px'>
          {intl.formatMessage(
            { id: 'Load.EmailSendingWizard.SegmentationInfo2' },
            { X: queued }
          )}
          <Link
            variant={LINK_VARIANT_DEFAULT_NEGATIVE}
            onClick={onSegmentationInfoClick}
            data-mu-test='segmentation-info-link'
          >
            {intl.formatMessage({
              id: 'Load.EmailSendingWizard.SegmentationInfoLink'
            })}
          </Link>
        </Flex>
      </MessageBox>
      <SpacingVertical variant={SPACING_24} />
    </>
  ) : null
}

export default SegmentationMessageBox
